import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
 // import {NotificationManager} from "react-notifications";
import {useForm} from "react-hook-form";

// import nprogress from "nprogress";
import {setNewPasswordAction} from "../actions";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"

var pjson = require('../../package.json'); //to display version number

const ChangePasswordForm = (props) => {

    const {authUser} = useSelector(({auth}) => auth);

  const isVoluntaryChange = !authUser.user.needs_password_reset;
  const { register, handleSubmit, errors } = useForm();


  const [newPassword, setNewPassword] = useState(null);
  // const [newPasswordConfirm, setNewPasswordConfirm] = useState(null);
  const dispatch = useDispatch();
  const {token} = useSelector(({auth}) => auth);
  const {loader} = useSelector(({auth}) => auth);

  const onSubmit = data => dispatch(setNewPasswordAction(data.newPassword));


  useEffect(() => {
    //stop the page loader
    // nprogress.done();

    // console.log("TOKEN CHECK. TOKEN IS", token, "local:", localStorage.getItem("token"))
    //console.log("REFRESH TOKEN CHECK. REFRESH TOKEN IS", refreshToken, "local:", localStorage.getItem("refreshToken"))
    //if there is a token set (if user is logged in), redirect to home page
    if (token === null) { //if the user is not logged in (and freshly signed in), send back to the login page
      props.history.push('/signin');
    }
  }, [props.history, dispatch, token, errors, authUser]);

  /*  jfd*******************************
   *   Form validation
       ********************************** */

  console.log("Changing password.  Is this a mandatory reset: ", isVoluntaryChange);
  const subTitle = isVoluntaryChange ?  <IntlMessages id="appModule.changePassword.details"/>: <IntlMessages id="appModule.changeDefaultPassword.details"/>;

  return (
      <React.Fragment>
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
      <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
              <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
            </a>
          </div>

        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1><IntlMessages id="appModule.changePassword.title"/></h1>
            <h4>{subTitle}</h4>
              <ul>
                  <li>At least 8 characters long</li>
                  <li>No more than 40 characters long</li>
                  <li>Not easily guessed</li>
                  <li>Not the same as your current password</li>
              </ul>
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>
                <TextField
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    required
                    error={!!errors.newPassword}
                  label={<IntlMessages id="appModule.changeDefaultPassword.newPassword"/>}
                  fullWidth
                  onChange={(event) => setNewPassword(event.target.value)}
                  margin="normal"
                  className="mt-1 my-sm-3"
                    inputRef={register({
                      required: "This field is required." ,
                      maxLength : {
                        value: 40,
                        message: "No more than 40 characters are allowed."
                      },
                      minLength : {
                        value: 8,
                        message: "No fewer than 8 characters are allowed." //<IntlMessages id="form.validation.noMatch"/> will throw an endless rerender
                      },
                    })}
                    helperText={errors.newPassword?.message}
                />
                <TextField
                  type="password"
                  id="newPasswordConfirm"
                  name="newPasswordConfirm"
                  error={!!errors.newPasswordConfirm}
                  required
                  label={<IntlMessages id="appModule.changeDefaultPassword.confirmNewPassword"/>}
                  fullWidth
                  // onChange={(event) => setNewPasswordConfirm(event.target.value)}
                  margin="normal"
                  className="mt-1 my-sm-3"
                  // onBlur={() => validatePasswordsMatch()}
                  inputRef={register({
                    required: "This field is required." ,
                    maxLength : {
                      value: 40,
                      message: "No more than 40 characters are allowed."
                    },
                    minLength : {
                      value: 8,
                      message: "No fewer than 8 characters are allowed." //<IntlMessages id="form.validation.noMatch"/> will throw an endless rerender
                    },
                    validate: {
                      matchPw: value => value === newPassword || "Passwords must match.",
                    }
                  })}
                  helperText={errors.newPasswordConfirm?.message}
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button onClick={handleSubmit(onSubmit)}
                          disabled={!!errors.newPasswordConfirm}
                          variant="contained" color="primary">
                    <IntlMessages id="appModule.changeDefaultPassword.submit"/>
                  </Button>

                  {isVoluntaryChange && //If this was not a mandatory reset, they can go back to the dashboard.
                    <Link to="/board/dashboard">
                      <IntlMessages id="form.goBackHome"/>
                    </Link>
                  }

                </div>

              </fieldset>
            </form>
          </div>
          <div id={"version"}> v. {`${pjson.version}`}</div>
        </div>

      </div>


      {
        loader &&
        <div className="loader-view">
          <CircularProgress/>
        </div>
      }

    </div>
      </React.Fragment>
  );
};


export default ChangePasswordForm;
